<template>
  <div class="page-wrap page-abstract-area">
    <draggable :group="{ name: 'group', sort: true }" :disabled="focusEl" @end="onEnd" :list="detailGroupList" class="draggable-abstract draggable-abstract-content" :style="{ height: props.type == 2 ? '100%' : '' }">
      <template #item="{ element, index }">
        <div class="drag-item hand">
          <div class="drag-item-hover">
            <div class="title-list" v-if="props.type != 2">
              <qfei-icon-more-two-outlined class="mover" />
              <jw-space>
                <span class="title-content"><jw-input @focus="handleFocus()" @blur="handleBlur()" :placeholder="$t('请输入分组名称')" :style="{ width: '240px' }" v-model="element.label" allow-clear></jw-input></span>
                <div class="operate-bottoms">
                  <jw-tooltip :content="$t('删除')" position="top" mini>
                    <qfei-icon-close-two-outlined class="icon-btn icon-delete-circle" size="18px" @click.stop.prevent="deleteItem(index)" />
                  </jw-tooltip>
                </div>
              </jw-space>
            </div>
            <!-- && [30, 35, 60].includes(useLayout.dragLayoutType) -->
            <draggable :disabled="isSysLayout" :group="{ name: 'itxst', sort: true, pull: true, put: props.type == 2 && (element.modules?.length >= 4 || useLayout.dragLayoutType != 20) ? false : true }" @end="onEnd" :move="onMove" :list="element.modules" :class="['draggable-abstract draggable-abstract2 abstract-class', props.type == 2 ? 'detail-draggable-abstract' : '', !element.modules?.length ? 'padding-bottom-0' : '']" :ghostClass="ghostClass">
              <template #item="{ element: ele, index: i }">
                <div :class="[getDragItemClasses(ele), curDragItemClass]" @click="selectAbstract(ele, index, i)" v-if="props.type == 1 && (ele.layoutFieldType == 20 || ele.layoutFieldType == 50)">
                  <!-- 以下是新建编辑字段区域 -->
                  <div :class="['drag-item-list-hover', (props.type != 2 && clickIndex == i && parentIndex == index) || (data.active === 'abs' && clickIndex == i && parentIndex == index) ? 'item-click' : '']" :data-parentIndex="index" :data-index="i">
                    <div class="form-content" :style="{ alignItems: formAttribute?.formLayout == 1 ? undefined : ele?.fieldType == 1 ? 'baseline' : 'center', width: '100%', minWidth: '100%' }">
                      <jw-form :model="ele.modules" label-align="left" class="layout-system-form" ref="editAddForm" :layout="formAttribute?.formLayout ? 'vertical' : 'horizontal'">
                        <jw-form-item asterisk-position="end" :rules="rules(ele)" :label-col-style="{ width: formAttribute?.formLayout ? 'calc(100% - 30px)' : '130px' }" :label-col-flex="formAttribute?.formLayout ? 'calc(100% - 30px)' : '130px'" :class="['form-label-text', ele.fieldType == 11 && ele?.defaultValue && !tools.checkLink(ele?.defaultValue) ? 'defaultValue-item-label-error' : '']">
                          <template #label>
                            <qfei-icon-more-two-outlined class="drag-mover" />
                            <component class="filed-icon" :is="componentFun(ele)" />
                            <xl-label-text cursor="pointer" :value="ele.label" :row="1" :key="ele.toast" layout="vertical" />
                            <jw-tooltip v-if="ele?.toast">
                              <qfei-icon-question-mark-outlined size="14" />
                              <!-- 这是提示文本  -->
                              <template #content> {{ ele.toast }} </template>
                            </jw-tooltip>
                          </template>
                          <!-- 字段组件 -->
                          <field-modules :list="element" :modules="ele" source="20" :parentIndex="index" :itemIndex="i"></field-modules>
                        </jw-form-item>
                      </jw-form>
                    </div>
                    <qfei-icon-close-two-outlined :class="['icon-close-circle', (props.type != 2 && clickIndex == i && parentIndex == index) || (data.active === 'abs' && clickIndex == i && parentIndex == index) ? 'icon-close-circle-show' : '']" v-if="isShowDelete(ele, index) || props.type == 2" size="18px" @click.stop.prevent="deleteAbstractItem(ele, index, i)" />
                    <!-- 对超链接校验 -->
                    <div v-if="ele.fieldType == 11 && ele?.defaultValue && !tools.checkLink(ele?.defaultValue)" class="tips-item-memo link-invalid" :style="getMemoPaddingLeft(ele)">格式不正确,请以http:// 或 https:// 开头,且不能包含汉字</div>
                    <!--附加说明 -->
                    <div class="tips-item-memo" v-if="ele?.memo" :title="ele?.memo" :style="getMemoPaddingLeft(ele)">{{ ele?.memo }}</div>
                  </div>
                </div>
                <div :class="['drag-item-list hand', props.type == 2 ? 'drag-item-detail' : '', isSysLayout ? 'drag-item-list-unover' : '', isCustomLayout ? 'custom-layout' : '']" @click="selectAbstract(ele, index, i)" v-else-if="props.type == 2 && (ele.layoutFieldType == 20 || ele.layoutFieldType == 50)">
                  <!-- 详情中的摘要区 -->
                  <div :class="['drag-item-list-hover', (props.type != 2 && clickIndex == i && parentIndex == index) || (data.active === 'abs' && clickIndex == i && parentIndex == index) ? 'item-click' : '', isCustomLayout ? 'custom-layout' : '']" :data-parentIndex="index" :data-index="i">
                    <tab-detail-label :ele="ele" type="abstract"></tab-detail-label>
                    <qfei-icon-close-two-outlined :class="['icon-close-circle', (props.type != 2 && clickIndex == i && parentIndex == index) || (data.active === 'abs' && clickIndex == i && parentIndex == index) ? 'icon-close-circle-show' : '']" v-if="!ele.isRequired || props.type == 2" size="18px" @click.stop.prevent="deleteAbstractItem(ele, index, i)" />
                    <div v-if="ele?.memo" class="tips-item-memo drag-item-memo" :title="ele?.memo">{{ ele?.memo }}</div>
                  </div>
                </div>
                <div :class="['hand', 'drag-item-list', 'drag-sub-form-item', 'drag-sub-form-item-35', `${ele.layoutFieldType}`, isSysLayout ? 'drag-item-list-unover' : '', isCustomLayout ? 'custom-layout' : '']" @click.stop.prevent="selectAbstract(ele, index, i)" v-else-if="ele.layoutFieldType == 35">
                  <!-- 子表单 -->
                  <div :class="['drag-item-list-hover ', (props.type != 2 && clickIndex == i && parentIndex == index && !isSubItem) || (data.active === 'abs' && parentIndex == index && clickIndex == i && !isSubItem) ? 'item-click' : '']" :data-parentIndex="index" :data-index="i">
                    <sub-form-table :element="ele" :parentIndex="index" :index="i" :ref="($event) => setRef($event, ele.id)" :formAttribute="formAttribute" />
                    <qfei-icon-close-two-outlined v-if="!ele.isRequired || props.type == 2" :class="['icon-close-circle', 'sub-icon-close', (props.type != 2 && clickIndex == i && parentIndex == index && !isSubItem) || (data.active === 'abs' && parentIndex == index && clickIndex == i && !isSubItem) ? 'icon-close-circle-show' : '']" size="18px" @click.stop.prevent="deleteAbstractItem(ele, index, i)" />
                  </div>
                </div>
                <div :class="['hand', 'drag-item-list', 'drag-sub-form-item', `drag-item-list-table${ele.layoutFieldType}`, isSysLayout ? 'drag-item-list-unover' : '', isCustomLayout ? 'custom-layout' : '']" @click="selectAbstract(ele, index, i)" v-else-if="getRecordType(ele.layoutFieldType)">
                  <!-- 关联对象表格 -->
                  <div :class="['drag-item-list-hover', (props.type != 2 && clickIndex == i && parentIndex == index) || (data.active === 'abs' && parentIndex == index && clickIndex == i) ? 'item-click' : '']" :data-parentIndex="index" :data-index="i" :style="{ flexDirection: 'column' }">
                    <div class="drag-sub-form-item-title" :style="{ maxWidth: 'calc(100% - 20px)' }">
                      <div class="label-icon">
                        <qfei-icon-more-two-outlined class="mover drag-mover" style="margin-top: 3px" />
                        <component class="filed-icon" :is="componentFun(ele)" />
                      </div>
                      <div class="table-label-box">
                        <xl-label-text cursor="pointer" :value="setRecordLabel(ele)" :row="1" :key="ele.toast" />
                      </div>
                      <span class="hint" v-if="ele.layoutFieldType == 30 && ele?.isRequired">*</span>
                    </div>
                    <association-table :source="30" :style="{ marginTop: '8px' }" :ele="ele"></association-table>
                    <qfei-icon-close-two-outlined :class="['icon-close-circle', (props.type != 2 && clickIndex == i && parentIndex == index) || (data.active === 'abs' && parentIndex == index && clickIndex == i) ? 'icon-close-circle-show' : '']" size="18px" @click.stop.prevent="deleteAbstractItem(ele, index, i)" />
                  </div>
                  <div class="hint" v-if="(ele?.layoutFieldType == 30 && (!ele?.associateKey || !ele?.businessData)) || (ele?.layoutFieldType == 31 && !ele?.businessData)" :style="{ marginLeft: '10px' }">请完善组件的必填内容</div>
                </div>
                <div :class="['hand', 'drag-item-list', `drag-sub-form-item`, `${ele.layoutFieldType}`, isSysLayout ? 'drag-item-list-unover' : '', isCustomLayout ? 'custom-layout' : '']" data-a="hand drag-item-list drag-sub-form-item" @click="selectAbstract(ele, index, i)" v-else-if="ele.layoutFieldType == 60">
                  <!-- 外链容器 -->
                  <div :class="['drag-item-list-hover', 'drag-item-list-table-hover', 'drag-item-frame', (props.type != 2 && clickIndex == i && parentIndex == index) || (data.active === 'abs' && parentIndex == index && clickIndex == i) ? 'item-click' : '']" :data-parentIndex="index" :data-index="i">
                    <qfei-icon-more-two-outlined class="mover table-mover" />
                    <div :class="['empty-subfield', `${ele.layoutFieldType}`]">{{ $t('外链容器') }}</div>
                    <qfei-icon-close-two-outlined :class="['icon-close-circle', (props.type != 2 && clickIndex == i && parentIndex == index) || (data.active === 'abs' && parentIndex == index && clickIndex == i) ? 'icon-close-circle-show' : '']" size="18px" @click.stop.prevent="deleteAbstractItem(ele, index, i)" />
                  </div>
                </div>
              </template>
              <!-- 当列表为空时显示的内容 -->
              <template #footer v-if="!element.modules?.length">
                <div class="empty-modules">
                  {{ type == 2 ? $t('摘要区暂无内容') : $t('暂无内容') }}
                </div>
              </template>
            </draggable>
          </div>
        </div>
      </template>
    </draggable>
  </div>
</template>

<script setup>
import { inject, reactive, watch, ref, computed, provide, onMounted } from 'vue';
import draggable from 'vuedraggable';
import { Modal } from '@arco-design/web-vue';
// 最新的图表
import { QfeiIconCloseTwoOutlined, QfeiIconMoreTwoOutlined, QfeiIconQuestionMarkOutlined } from '@qfei-design/icons-vue';
import tabDetailLabel from '../tab-detail-label/tab-detail-label.vue';
import subFormTable from '@/views/setting/sys-fields/page-layout/components/sub-form-table/sub-form-table.vue';
import fieldModules from '@/views/setting/sys-fields/page-layout/components/field-modules/field-modules.vue';
import associationTable from '../association-table/association-table.vue';
import useLoading from '@/hooks/loading';
import { useI18n } from 'vue-i18n';
import { tools } from '@/utils/tools';

import { useLayoutStore } from '@/store';
import { useGrayscaleStore } from '@/store';
import useObjectForm from '@/hooks/object-form';
const { getRecordType, setRecordLabel, componentFun } = useObjectForm();

const { setLoading } = useLoading(false);
const useLayout = useLayoutStore(); //store
const isDragIng = ref(false);
const { t } = useI18n();

const splitType = inject('sharedConfigData')?.splitType; // 布局分裂模式
const { grayList } = useGrayscaleStore();
setLoading(false);
const props = defineProps({
  data: {
    //展示的数据
    type: Array,
    default: () => []
  },
  groupList: {
    //分组的数量
    type: Array,
    default: () => [{ id: 1, label: '未命名分组', modules: [] }]
  },
  type: {
    //布局类型，类型不同，展示的效果不同
    //1:新增/编辑，2:详情布局
    type: [Number, String],
    default: 0
  },
  saveCopyType: {
    type: [String],
    default: ''
  },
  formAttribute: {
    type: Object
  }
});
console.log('props123', props);
const getDraggableH = ref();
const subFormDataRefs = reactive({}); //子表单的ref
const setRef = (e, id) => {
  //设置ref
  subFormDataRefs[`subForm${id}`] = e;
};

// 与表单设计同步
const isSysLayout = computed(() => {
  return splitType?.value == 2;
});

// 自定义布局
const isCustomLayout = computed(() => {
  return splitType?.value == 3;
});
const displayOneLineFields = [18, 26]; //整行显示的字段

const rules = (basic) => {
  if (basic.isRequired == 1) {
    if (basic.fieldType === 0 || basic.fieldType === 1) {
      ////1必填 2 非必填
      return {
        required: basic.isRequired,
        message: `${basic.fieldName}` + t('是必填项')
      };
    } else {
      return {
        required: basic.isRequired,
        message: `${basic.fieldName}` + t('是必选项')
      };
    }
  } else {
    return {};
  }
};
const detailGroupList = ref(props.groupList);
//如果用户设置不显示默认值，则将默认值修改为空
detailGroupList.value.map((v) => {
  if (v?.modules?.length) {
    v.modules.map((vm) => {
      if (vm?.type == 20) {
        if (vm?.isExistDefValue == 0 || vm?.isExistDefValue == null) {
          vm.defaultValue = null;
        }
      }
    });
  }
});
const focusEl = ref(false);
const handleFocus = () => {
  focusEl.value = true;
};
const handleBlur = () => {
  focusEl.value = false;
};
const updateDefault = () => {
  // 新增页 复制 编辑页布局  修改isExistDefValue
  if (props.saveCopyType == '1') {
    detailGroupList.value.forEach((v) => {
      if (v?.modules?.length) {
        v.modules.forEach((vm) => {
          if (vm.value == 'departmentIds' || vm.value == 'followUser' || vm.value == 'chargePerson' || vm.value == 'csmChargePerson') {
            vm.isExistDefValue = 2;
          }
        });
      }
    });
  }
  // 编辑页 复制  新增页布局  修改businessData
  if (props.saveCopyType == '0') {
    detailGroupList.value.forEach((v) => {
      if (v?.modules?.length) {
        v.modules.forEach((vm) => {
          if (vm.businessData == null || vm.businessData == '') {
            vm.businessData = '1';
          }
          if (vm.value == 'followUser' || vm.value == 'chargePerson' || vm.value == 'csmChargePerson') {
            vm.businessData = '0';
          }
        });
      }
    });
  }
};

const data = reactive({
  drag: false, //拖拽
  layoutId: inject('layout')?.layoutId,
  active: inject('sharedConfigData')?.active
});
const emits = defineEmits(['sendData', 'groupList']);

onMounted(() => {
  focusEl.value = false;
});
const clickIndex = ref();
const parentIndex = ref();
const isSubItem = ref(false); //点击的是否是子字段

//拖拽结束事件
const onEnd = () => {
  updataConfig();
};
const updataConfig = () => {
  const content = document.querySelectorAll('.draggable-abstract2');
  for (var i = 0; i < content?.length; i++) {
    if (content[i]?.querySelectorAll('.item-click')) {
      const itemClickElements = content[i]?.querySelectorAll('.item-click');
      const parentIndex = itemClickElements?.[0]?.dataset.parentindex;
      const childIndex = itemClickElements?.[0]?.dataset.index;
      if ((parentIndex || parentIndex == 0) && (childIndex || childIndex == 0)) {
        let modules = null;
        let isSubForm = false;
        if (useLayout.selectSubIndex != null && detailGroupList.value[parentIndex]?.modules[childIndex]?.layoutFieldType == 35) {
          modules = detailGroupList.value[parentIndex]?.modules[childIndex]?.modules?.[useLayout.selectSubIndex];
          isSubForm = true;
        } else {
          modules = detailGroupList.value[parentIndex]?.modules[childIndex];
          useLayout.setSelectSubIndex(null);
        }
        emits('sendData', { page: data.layoutId, modules: modules, parentIndex: parentIndex, index: childIndex, active: 'abs', isSubForm });
      }
    }
  }

  data.drag = false;

  updateDefault();
};
// 拖动事件
const onMove = (e) => {
  delete e.draggedContext.element.id;
  delete e.draggedContext.element.parentId;
};

const submitNotice = (i, vi, item) => {
  selectAbstract(item, i, vi);
};
// 子字段点之前需要清空其他子字段的选中状态
const clearSubFormStatus = () => {
  if (subFormDataRefs) {
    for (const i in subFormDataRefs) {
      subFormDataRefs[i]?.setClickStatus();
    }
  }
};
// 点群组内的字段
const selectAbstract = (item, index, i, isSubForm = false) => {
  if (grayList['Layout:viewInit']) {
    return;
  }
  if (getRecordType(item.layoutFieldType) && item?.version == 1) {
    //从表单设计新增不可点击，只能删除
    return;
  }
  //点击子表单清空子字段选项
  if (item.fieldType == 27) {
    useLayout.setSelectSubIndex(null);
  }
  if (item?.parentFieldType != 27) {
    //点击的非子字段
    clearSubFormStatus();
  }
  clickIndex.value = i;
  parentIndex.value = index;
  isSubItem.value = isSubForm;
  emits('sendData', { page: data.layoutId, modules: item, parentIndex: index, index: i, active: 'abs', isSubForm });
};

const deleteAbstractItem = (item, parentIndex, index) => {
  console.log('删除摘要内容', item, parentIndex, index);
  detailGroupList.value[parentIndex].modules.splice(index, 1);
  emits('sendData', { delete: true, modules: [item] });
};
// 是否允许删除
const isShowDelete = (ele, index) => {
  const fieldKeyList = detailGroupList.value[index].modules.filter((el) => el.addIsRequired == true)?.map((v) => v.value);
  if (fieldKeyList?.includes(ele.value)) {
    return false;
  } else {
    return true;
  }
};
const deleteItem = (index) => {
  const isDelLens = detailGroupList.value[index].modules.filter((el) => el.addIsRequired == true);
  if (props.type == 1 && isDelLens?.length) {
    //新增布局 有必填字段时不能删除
    Modal.warning({
      titleAlign: 'start',
      width: 400,
      simple: false,
      title: t('温馨提示'),
      content: t('tips.delModule'),
      onOk: () => {}
    });
    return;
  }
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: t('tips.delModuleSure'),
    content: t('tips.delModuleBox'),
    onOk: () => {
      emits('sendData', { delete: true, modules: detailGroupList.value[index].modules });
      detailGroupList.value.splice(index, 1);
    }
  });
};
// 点击子字段
const clickSubItem = (e, item, index, i, mi) => {
  e.stopPropagation();
  useLayout.setSelectSubIndex(mi);
  selectAbstract({ ...item, ...{ parentFieldType: 27 } }, index, i, true);
};
// 抽离的动态class计算方法
const getDragItemClasses = (ele) => {
  // 基础类名处理，通过逻辑与简化条件判断，过滤空值
  const classes = ['drag-item-list', 'hand', splitType?.value === 2 && 'drag-item-list-unover', isCustomLayout.value && 'custom-layout'].filter(Boolean);
  // 解构元素属性
  const { fieldType, displayOneLine } = ele || {};
  // 统一映射表管理所有displayOneLine情况
  if (displayOneLineFields.includes(fieldType)) {
    classes.push('card-form-line');
  } else {
    // 映射表整合所有displayOneLine可能值（包括null）的类名规则
    const displayMap = {
      null: props.formAttribute?.displayOneLine === 1 ? 'card-form-line' : '',
      1: 'card-form-line',
      2: 'one-third',
      3: 'two-thirds'
    };
    // 根据displayOneLine获取目标类名，不存在时取空字符串
    const targetClass = displayMap[displayOneLine] || '';
    if (targetClass) {
      classes.push(targetClass);
    }
  }
  return classes;
};
const getMemoPaddingLeft = (ele) => {
  // 计算paddingLeft的值
  let paddingLeft;
  if (props.formAttribute?.formLayout) {
    paddingLeft = '0px';
  } else {
    if (ele.displayOneLine === null) {
      if (props.formAttribute?.displayOneLine == 1) {
        paddingLeft = '130px';
      } else {
        paddingLeft = '140px';
      }
    } else {
      if (ele?.displayOneLine == 1) {
        paddingLeft = '130px';
      } else {
        paddingLeft = '140px';
      }
    }
  }
  // 返回样式对象
  return { paddingLeft };
};
provide('publicMethods', {
  sendModule: clickSubItem,
  clearSubFormStatus: clearSubFormStatus,
  selectModules: selectAbstract
});

provide('groupingData', {
  detailData: computed(() => detailGroupList.value)
});
watch(
  () => detailGroupList.value,
  (v) => {
    emits('update:groupList', v);
    updataConfig();
  },
  {
    deep: true
  }
);

watch(
  () => useLayout.dragIng,
  (v) => {
    isDragIng.value = v;
  },
  {
    deep: true
  }
);
const curDragItemClass = ref('');
// 被拖拽元素
const ghostClass = ref('ghost-dragg');
watch(
  () => useLayout.dragList,
  (v) => {
    const isOneLine = [18, 26, 27].includes(v?.fieldType) || [30, 31, 35, 60].includes(Number(v.layoutFieldType)) || props.formAttribute?.displayOneLine == 1;
    ghostClass.value = isOneLine ? 'ghost-dragg-oneline' : 'ghost-dragg';
    if (props.formAttribute?.displayOneLine == 1) {
      curDragItemClass.value = 'card-form-line';
    }
  },
  {
    deep: true
  }
);
watch(
  () => detailGroupList.value.length,
  () => {
    const draggableDom = document.querySelectorAll('.draggable-abstract-content')[0];
    getDraggableH.value = draggableDom?.offsetHeight;
  },
  {
    deep: true
  }
);
defineExpose({ submitNotice, getDraggableH });
</script>
<style scoped lang="less">
@import './abstract-area.less';
</style>
